import React, { useState, useEffect } from 'react';

import { Carousel, QuickFilterButton } from '@hpstellar/core';


export default ({ quickFilters, quickFilterActive, setQuickFilter, isMobile, quickFilterTitle }) => {
    const [inpActive, setInpActive] = useState(null);

    useEffect(() => {
        if(typeof inpActive === 'number'){
            setInpActive(null);
        }
    }, [quickFilterActive])

    const getOnClick = (href, i) => () => {
        setInpActive([inpActive, quickFilterActive].includes(i) ? -1 : i);
        setTimeout(() => {
            setQuickFilter(href, i)
        }, 0);
    }

    const derivedActive = typeof inpActive === 'number' ? inpActive : quickFilterActive;

    const settings = {
        arrows: false,
        dots: true,
        infinite: false,
        variableWidth: true,
    };

    const comp = Array.isArray(quickFilters) && quickFilters.map((f, i) => {
        let isActive = i === derivedActive;
        return f && (
            <QuickFilterButton
                key={`${f.label}-${i}`}
                className={`quickFilter${i === 0 ? ' quickFilterFirst' : ''}`}
                onClick={getOnClick(f.href, i)}
                isActive={isActive}
                gtmActions={f && f.gtmActions}
                data-gtm-checked={!isActive}
            >
                <h4>{f.label}</h4>
            </QuickFilterButton>
        );
    })


    return isMobile ? (
        <Carousel className="filterCarousel" style={{ maxWidth: '100vw' }} {...settings}>
            {comp}
        </Carousel>
    ) : (
        <div className="quick-filter-container ">
            {quickFilterTitle}
            {comp}
        </div>
    );
}